import React from 'react';

const SpeakerCardSkeleton = () => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden animate-pulse">
      <div className="h-24 bg-gray-200 dark:bg-gray-700" />
      <div className="relative -mt-12 flex justify-center">
        <div className="w-28 h-28 rounded-full bg-gray-200 dark:bg-gray-700 border-4 border-white dark:border-gray-800" />
      </div>
      <div className="p-4 pt-3 text-center space-y-2">
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-2/3 mx-auto" />
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mx-auto" />
        <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mx-auto" />
        <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded-full w-16 mx-auto mt-3" />
        <div className="flex justify-center gap-1.5 mt-3">
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-full w-16" />
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-full w-20" />
        </div>
      </div>
    </div>
  );
};

const SpeakerCardSkeletonGrid = ({ count = 8 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <SpeakerCardSkeleton key={i} />
      ))}
    </div>
  );
};

export { SpeakerCardSkeletonGrid };
export default SpeakerCardSkeleton;
